/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreOpsChecklistUpdate
 */
export interface PreOpsChecklistUpdate {
    /**
     * 
     * @type {string}
     * @memberof PreOpsChecklistUpdate
     */
    label?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PreOpsChecklistUpdate
     */
    minutesUntilLogout?: number | null;
}

/**
 * Check if a given object implements the PreOpsChecklistUpdate interface.
 */
export function instanceOfPreOpsChecklistUpdate(value: object): value is PreOpsChecklistUpdate {
    return true;
}

export function PreOpsChecklistUpdateFromJSON(json: any): PreOpsChecklistUpdate {
    return PreOpsChecklistUpdateFromJSONTyped(json, false);
}

export function PreOpsChecklistUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreOpsChecklistUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'minutesUntilLogout': json['minutesUntilLogout'] == null ? undefined : json['minutesUntilLogout'],
    };
}

export function PreOpsChecklistUpdateToJSON(json: any): PreOpsChecklistUpdate {
    return PreOpsChecklistUpdateToJSONTyped(json, false);
}

export function PreOpsChecklistUpdateToJSONTyped(value?: PreOpsChecklistUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'minutesUntilLogout': value['minutesUntilLogout'],
    };
}

